import get from 'lodash.get';

export const selectAlerts = (state) => get(state, 'alerts', []);
export const selectIsLoading = (state) => get(state, 'isLoading', false);
export const getSelectedAlertIds = (state) => get(state, 'selectedAlertIds', []);
export const selectOrdersForShipTogether = (state) => get(state, 'ordersForShipTogether', []);
export const selectAlertFromAlertId = (state, props) => selectAlerts(state).filter((alert) => alert.alertId === props.alertId)[0];
export const getIsLoadingOrders = (state) => get(state, 'isLoadingOrders', false);
